import { useCallback, useEffect, useState } from "react";
import { fetchPublicPlans } from "../utils/subscriptionData";

// GET /plans is public and shared by the pricing page, the billing page and the plan picker.
// One request serves them all until a screen asks to retry.
let cached = null;
let pending = null;

const load = (force = false) => {
  if (force) cached = null;
  if (cached) return Promise.resolve(cached);
  if (!pending) {
    pending = fetchPublicPlans()
      .then((plans) => {
        cached = plans;
        return plans;
      })
      .finally(() => {
        pending = null;
      });
  }
  return pending;
};

const usePublicPlans = () => {
  const [state, setState] = useState({ plans: cached || [], loading: !cached, error: false });

  const run = useCallback((force = false) => {
    setState((previous) => ({ ...previous, loading: !cached || force, error: false }));
    return load(force)
      .then((plans) => setState({ plans, loading: false, error: false }))
      .catch(() => setState({ plans: [], loading: false, error: true }));
  }, []);

  useEffect(() => {
    let active = true;
    load()
      .then((plans) => active && setState({ plans, loading: false, error: false }))
      .catch(() => active && setState({ plans: [], loading: false, error: true }));
    return () => {
      active = false;
    };
  }, []);

  return { ...state, retry: () => run(true) };
};

export default usePublicPlans;
